import React, { useMemo, useState } from 'react';
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { format } from 'date-fns';
import { IFileInfo } from '../../../../api/load-balancer';

interface FileTableProps {
  uploadedFiles: IFileInfo[];
  onDelete: (filename: string) => void;
}

const FileTable: React.FC<FileTableProps> = ({ uploadedFiles, onDelete }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [sortBy, setSortBy] = useState<string>('name');
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');

  const handleSort = (field: string) => {
    const isAsc = sortBy === field && sortOrder === 'asc';
    setSortOrder(isAsc ? 'desc' : 'asc');
    setSortBy(field);
  };

  const uploadFilesInPage = useMemo(() => {
    const sortedFiles = [...uploadedFiles].sort((a, b) => {
      const isAsc = sortOrder === 'asc';
      if (sortBy === 'name') {
        return isAsc ? a.filename.localeCompare(b.filename) : b.filename.localeCompare(a.filename);
      } else {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return isAsc ? dateA.getTime() - dateB.getTime() : dateB.getTime() - dateA.getTime();
      }
    });
    return sortedFiles.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [page, rowsPerPage, uploadedFiles, sortBy, sortOrder]);

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell onClick={() => handleSort('name')} style={{ cursor: 'pointer', fontSize: '15px' }}>
              File Name {sortBy === 'name' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
            </TableCell>
            <TableCell onClick={() => handleSort('date')} style={{ cursor: 'pointer', fontSize: '15px' }}>
              Date {sortBy === 'date' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
            </TableCell>
            <TableCell style={{ fontSize: '15px' }}>Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {uploadFilesInPage.map((file) => (
            <TableRow key={file.filename}>
              <TableCell style={{ fontSize: '15px' }}>{file.filename}</TableCell>
              <TableCell style={{ fontSize: '15px' }}>
                {format(new Date(file.createdAt), 'MM/dd/yyyy, hh:mm:ss a')}
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  style={{ backgroundColor: '#ed6923', color: '#fff' }}
                  onClick={() => onDelete(file.filename)}
                >
                  Delete
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={uploadedFiles.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => setRowsPerPage(parseInt(event.target.value, 10))}
      />
    </TableContainer>
  );
};

export default FileTable;
